var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{attrs:{"src":_vm.tileImage,"alt":_vm.pictogramTile.name,"title":_vm.pictogramTile.name}})}
var staticRenderFns = []

export { render, staticRenderFns }